import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PulseLoader } from "react-spinners";
import { useOperator } from "../../utils/OperatorContext";
import { Day1 } from "./modules/day-1/day-1";
import { Day2 } from "./modules/day-2/day-2";
import Day3 from "./modules/day-3/day-3";
import Day4 from "./modules/day-4/day-4";
import Day6 from "./modules/day-6/day-6";
import { GlobalDisplayComponent } from "./modules/global/globalDisplayComponent";
import Day7 from "./modules/day-7/day-7";
import Day5 from "./modules/day-5/day-5";

function HomeComponent() {
  const { selectedDay } = useOperator();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(t);
  }, [selectedDay]);

  const renderDayComponent = () => {
    switch (selectedDay) {
      case "GLOBAL":
        return <GlobalDisplayComponent />;
      case "Day-1":
        return <Day1 />;
      case "Day-2":
        return <Day2 />;
      case "Day-3":
        return <Day3 />;
      case "Day-4":
        return <Day4 />;
      case "Day-5":
        return <Day5 />;
      case "Day-6":
        return <Day6 />;
      case "Day-7":
        return <Day7 />;

      default:
        return <div className="text-muted">No component for {selectedDay}</div>;
    }
  };

  return (
    <motion.div
      className="flex flex-col items-center justify-center overflow-hidden min-h-screen bg-background text-foreground p-6"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <motion.div
        className="p-6 rounded-2xl w-full "
        initial={{ scale: 0.98, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        {loading ? (
          <div className="flex items-center justify-center py-16">
            <PulseLoader />
          </div>
        ) : (
          <AnimatePresence mode="wait">{renderDayComponent()}</AnimatePresence>
        )}
      </motion.div>
    </motion.div>
  );
}
export default HomeComponent;
